<template>
  <el-dialog
    title="申诉内容"
    :visible.sync="$_visible"
    width="500px">
    <span>主动放弃任务将在一周内无法接受任务！</span>
    <span slot="footer">
      <el-button
        size="small"
        @click="closeDialog">
        取消
      </el-button>
      <el-button
        size="small"
        type="danger"
        plain
        :loading="btnLoading"
        @click="abandonTask">
        放弃任务
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from '@/api/index'
export default {
  props: {
    // 父组件传来的控制
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      btnLoading: false
    }
  },
  computed: {
    $_visible: {
      get () {
        return this.visible
      },
      set (newValue) {
        this.$emit('update:visible', newValue)
      }
    },
    taskId: {
      get () {
        return this.$route.params.taskId
      }
    }
  },
  methods: {
    abandonTask () {
      this.btnLoading = true
      api.abandonTask(this.taskId).then(res => {
        this.btnLoading = false
        console.log(res)
        if (res.data.code === 0) {
          this.$message.success('操作成功')
          this.closeDialog()
          this.$router.push('/user/task-manager')
        } else {
          this.$message.error('操作失败')
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error('请求异常')
      })
    },
    // 关闭dialog
    closeDialog () {
      this.$_visible = false
    }
  }
}
</script>
